import React from 'react';

import styles from './title_box.module.css';

const TitleBox = ({ text, strong }) => {
  return (
    <div className={styles.titleBox}>
      {text || ''}
      <br />
      <strong>{strong || ''}</strong>
    </div>
  );
};

export default TitleBox;
